var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slice',[_c('div',{staticClass:"slicelettercampaign"},[(_vm.isLoading)?_c('div',{staticClass:"loading-indicator"},[_c('div',{staticClass:"spinner"}),_c('span',[_vm._v("Loading...")])]):_vm._e(),_c('div',{staticStyle:{"width":"100%"},attrs:{"id":"Letter-Campaign"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }